
import React from "react";
import intl from "react-intl-universal";

import {ContextMenuInterface} from "../../ContextMenuInterface";

import {ImageSmallIcon} from "../../../../components/icons/editor/ImageSmallIcon";
import {ImageNormalIcon} from "../../../../components/icons/editor/ImageNormalIcon";
import {ImageLargeIcon} from "../../../../components/icons/editor/ImageLargeIcon";
import {DeleteIcon} from "../../../../components/icons/DeleteIcon";

import {setViewSizeSmall, setViewSizeNormal, setViewSizeLarge} from "../../../../../Editor/module/commands/common/size";

import {deleteImage} from "../../../../../Editor/module/commands/image/deleteImage";
import {isAttributeValueActive} from "../../../../../Editor/utils/isAttributeValueActive";

import {schema} from '../../../../../Editor/module/config/schema';


import {GroupedActions, ContextAction} from "../utils/GroupedActions";


export interface ImageContextPropsSelfProps {
    getPos: () => number | undefined,
}

export interface ImageToolbarProps extends ContextMenuInterface, ImageContextPropsSelfProps {
}

const sizeActions: ContextAction[]  = [
    {
        id: 'small',
        Icon: ImageSmallIcon,
        getTitle: () => intl.get('image-toolbar.small').d('Small'),
        action: setViewSizeSmall,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'small'),
    },
    {
        id: 'normal',
        Icon: ImageNormalIcon,
        getTitle: () => intl.get('image-toolbar.normal').d('Normal'),
        action: setViewSizeNormal,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'normal'),
    },
    {
        id: 'large',
        Icon: ImageLargeIcon,
        getTitle: () => intl.get('image-toolbar.large').d('Large'),
        action: setViewSizeLarge,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'large'),
    },
]


const deleteActions: ContextAction[] = [
    {
        id: 'delete',
        Icon: DeleteIcon,
        getTitle: () => intl.get('common.delete').d('Delete'),
        action: deleteImage,
    },
]

const groupedActions: ContextAction[][] = [
    sizeActions,
    deleteActions,
];


export const EmbedToolbar = ({handleClose, isDark, ...specificParams}: ImageToolbarProps) => {
    return <GroupedActions
        handleClose={handleClose}
        actionGroups={groupedActions}
        additionalParams={specificParams}
        isDark={isDark}
    />
}
